"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

var _mobxReact = require("mobx-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ResizeHandle = _interopRequireDefault(require("./ResizeHandle"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      overflowY: 'auto',
      height: '100%',
      zIndex: theme.zIndex.drawer,
      outline: 'none',
      background: theme.palette.background.default
    },
    resizeHandle: {
      width: 4,
      position: 'fixed',
      top: 0,
      zIndex: theme.zIndex.drawer + 1
    }
  };
});

function Drawer(_ref) {
  var children = _ref.children,
      session = _ref.session;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: classes.paper,
    elevation: 16,
    square: true
  }, /*#__PURE__*/_react.default.createElement(_ResizeHandle.default, {
    onDrag: session.resizeDrawer,
    className: classes.resizeHandle,
    vertical: true
  }), children);
}

Drawer.propTypes = {
  children: _propTypes.default.node,
  session: _mobxReact.PropTypes.observableObject.isRequired
};
Drawer.defaultProps = {
  children: null
};

var _default = (0, _mobxReact.observer)(Drawer);

exports.default = _default;